// 先載入樣式（輕量）
import 'vuetify/styles'
import '@mdi/font/css/materialdesignicons.css'

// 動態載入大型模組，避免首屏解析時主線程卡死
async function bootstrap() {
  const [{ createApp }, { createPinia }, { default: App }, { default: router }, { createVuetify }, components, directives] = await Promise.all([
    import('vue'),
    import('pinia'),
    import('./App.vue'),
    import('./router'),
    import('vuetify'),
    import('vuetify/components'),
    import('vuetify/directives')
  ])

  const vuetify = createVuetify({
    components,
    directives,
    theme: {
      defaultTheme: 'light',
      themes: {
        light: {
          dark: false,
          colors: {
            primary: '#2196F3',
            secondary: '#424242',
            accent: '#FF4081',
            error: '#FF5252',
            info: '#2196F3',
            success: '#4CAF50',
            warning: '#FB8C00',
          }
        }
      }
    }
  })

  const pinia = createPinia()
  const app = createApp(App)
  app.use(pinia)
  app.use(router)
  app.use(vuetify)
  app.mount('#app')
}

bootstrap()
